import React, { useEffect } from "react";
import { IDataSource, IDataSourceBinding } from "./data-source-picker/datasource";
import { DataSourcePropertyEditor } from "./ui-props/DataSourceProperty";
import { IContextProvider } from "../../uxp";
import { IWDDesignModeProps } from "./common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "uxp/components";
import './MultipleDataSourceEditor.scss';

interface IMultipleDataSourceEditorProps {
    sources: IDataSource[],
    bindings: IDataSourceBinding[]
    uxpContext: IContextProvider,
    contextData?: any
    designer: IWDDesignModeProps,
    onChange: (key: 'sources' | 'binding', values: IDataSource[] | IDataSourceBinding[]) => void
}

export const MultipleDataSourceEditor: React.FunctionComponent<IMultipleDataSourceEditorProps> = (props) => {

    const { sources, bindings, uxpContext, designer, contextData, onChange } = props

    useEffect(() => {
        console.log('sources__', sources, bindings)
    }, [props])

    function onAddSource(key: string, value: any) {
        if (key == 'sources') onChange('sources', value)
        else {
            const _bindings = structuredClone(bindings)
            _bindings.push(value)
            onChange('binding', _bindings)
        }
    }

    function removeSource(id: string) {
        const _sources = structuredClone(sources || [])?.filter((s: IDataSource) => s.id !== id)
        onChange('sources', _sources)

        const _bindings = structuredClone(bindings || [])?.filter((b: IDataSourceBinding) => b.source !== id)
        onChange('binding', _bindings)


    }

    function onUpdateSource(key: string, value: any, oldId: string) {
        if (key == 'sources') onChange('sources', value)
        else {
            let _bindings = structuredClone(bindings || []) as IDataSourceBinding[]
            const index = _bindings.findIndex(b => b.source == oldId)
            const _new: IDataSourceBinding = value

            if (_new.source === oldId) {
                _bindings[index] = _new
            }
            else {
                _bindings.splice(index, 1, _new)
            }
            onChange('binding', _bindings)
        }
    }

    return <div className="wd-multiple-source-editor">

        <div className="wd-multiple-source-editor-add">

            <DataSourcePropertyEditor
                title="Add a new source"
                binding={null}
                sources={sources}
                target={'any'}
                onChange={(value) => { onAddSource('binding', value) }}
                onChangeAny={(path, value) => { onAddSource('sources', value) }}
                context={uxpContext}
                contextData={contextData}
                designer={designer}
                hideLabels={true}
                hideAdvancedOptions={true}
                renderButton={() => <Button
                    className="new-option"
                    title="Add Data Source"
                    icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                    iconPosition="right"
                    onClick={() => {
                    }}
                />}
                buttonContainerClassName="multiple-datasource-add-button"
            />
        </div>
        <div className="wd-multiple-source-editor-list">

            {
                bindings?.map((b, i) => {
                    return <div className="wd-multipl-source-editor-source">
                        <DataSourcePropertyEditor
                            title={'Add a data source'}
                            binding={b}
                            sources={sources}
                            target={null}
                            onChange={(val) => { onUpdateSource('binding', val, b.source) }}
                            onChangeAny={(path, val) => { onUpdateSource('sources', val, b.source) }}
                            context={uxpContext}
                            contextData={contextData}
                            designer={designer}
                            hideLabels={true}
                        // hideAdvancedOptions={true}
                        />

                        <div className="wd-initial-source-remover"
                            onClick={() => removeSource(b.source)}
                        >
                            <FontAwesomeIcon icon={['fas', 'times']} />
                        </div>
                    </div>
                })
            }
        </div>
    </div>
}